import { useAppSelector } from "store/hooks";
import { getLandedCampaignSearch } from "utils/campaignParams";

/**
 * Returns the campaign-tracking query string (cc, sc, cmp) the user actually
 * landed with, derived from the campaign URL stored in Redux. Empty string
 * when the landing URL carried no campaign params.
 */
export const useCampaignSearch = (): string => {
    const campaignUrl = useAppSelector((state) => state.application.landingPageData?.campaign?.campaignUrl);
    return getLandedCampaignSearch(campaignUrl);
};
